import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import UserApi from "../../apis/user.api";
import AppAlert from "../../components/AppAlert";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import AppInput from "../../components/controls/AppInput";
import Spinner from "../../components/spinner/Spinner";
import TopPageBack from "../../components/TopPageBack";
import { RESULT_CODE } from "../../constants/AppConstants";
import { ROUTE_PATHS } from "../../constants/Router";
import useAuth from "../../hooks/useAuth";
import AppUtils from "../../utils";

const Representative = function () {
  const [openNoResult, setOpenNoResult] = useState(false);
  const [openIncorrectNumber, setOpenIncorrectNumber] = useState(false);
  const [loading, setLoading] = useState(false);

  const [otpLoading, setOtpLoading] = useState(false);

  const { ceoInfo } = useAuth();
  const navigate = useNavigate();

  const schema = yup.object().shape({
    biz_no: yup.string().required(),
    owner_name: yup.string().required(),
    owner_phone_no: yup.string().required(),
  });
  const { control, handleSubmit, watch } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    const removedDashPhoneNumber = AppUtils.replaceDash(data.owner_phone_no);
    if (
      removedDashPhoneNumber.length >= 9 &&
      removedDashPhoneNumber.length <= 11 &&
      removedDashPhoneNumber.startsWith("010")
    ) {
      if (ceoInfo?.shop_idx) {
        try {
          setLoading(true);
          const res = await UserApi.getShopInfoBeforeDelete(ceoInfo?.shop_idx);
          if (res.data?.data) {
            const { biz_no, owner_name, owner_phone_no } = res.data?.data;

            if (
              AppUtils.replaceDash(data.biz_no) !== biz_no ||
              data?.owner_name.replaceAll(' ','') !== owner_name.replaceAll(' ','') ||
              AppUtils.replaceDash(data?.owner_phone_no) !== owner_phone_no
            ) {
              setOpenNoResult(true);
            } else {
              try {
                setOtpLoading(true);
                const res = await UserApi.sendOtp({
                  shopIdx: ceoInfo?.shop_idx,
                  phone: removedDashPhoneNumber,
                });

                if (
                  res.data &&
                  res.data.result_code !== RESULT_CODE.NO_RESULT
                ) {
                  navigate(ROUTE_PATHS.VerifyCode, {
                    state: {
                      data,
                      phoneNumber: data.owner_phone_no,
                      shopIdx: ceoInfo?.shop_idx,
                      type: "representative",
                    },
                  });
                }
              } finally {
                setOtpLoading(false);
              }
            }
          }
          else {
            setOpenNoResult(true);
          }
        } finally {
          setLoading(false);
        }
      }
    } else {
      setOpenIncorrectNumber(true);
    }
  };

  const values = watch();

  return (
    <div>
      <TopPageBack>
        <b>대표자 인증</b>
      </TopPageBack>
      <div className="h-4"></div>
      <div className="mx-5">
        <form onSubmit={handleSubmit(onSubmit)}>
          <AppInput
            control={control}
            name="biz_no"
            placeholder="숫자만 입력해 주세요."
            label="사업자등록번호"
            className="mb-5"
            type="number"
          />

          <AppInput
            control={control}
            name="owner_name"
            placeholder="대표자명을 입력해 주세요."
            label="대표자명"
            className="mb-5"
          />

          <AppInput
            control={control}
            name="owner_phone_no"
            placeholder="숫자만 입력해 주세요."
            label="휴대폰 번호"
            maximum={11}
            isKoreaPhoneNumber
            type="number"
          />

          <div className="px-5 absolute w-full bottom-2 left-0">
            <SolidBlueBtn
              disabled={
                !values.biz_no ||
                !values.owner_phone_no ||
                !values.owner_name ||
                loading ||
                otpLoading
              }
              className="w-full mt-5 flex items-center justify-center "
              type="submit"
            >
              <Spinner isLoading={loading || otpLoading} />
              인증번호 받기
            </SolidBlueBtn>
          </div>
        </form>
      </div>

      <AppAlert
        title="가맹점 정보가 일치하지 않아요."
        desc="정보를 다시 한번 확인해 주세요."
        open={openNoResult}
        onOk={() => setOpenNoResult(false)}
        okText="확인"
        type="error"
      />

      <AppAlert
        title="휴대폰 번호가 올바르지 않아요."
        desc="번호를 다시 한번 확인해 주세요."
        open={openIncorrectNumber}
        onOk={() => setOpenIncorrectNumber(false)}
        okText="확인"
        type="error"
      />
    </div>
  );
};
export default Representative;
